import gql from 'graphql-tag'

// Event-data shared between event and event-type pages.
export const sharedEventDataFragment = gql`
  fragment sharedEventData on Event {
    id
    slug
    name
    status
    isSellingBlocked
    isBuyingBlocked
    isPopular
    category
    instagramUsername
    startDate
    endDate
    facebookEventWalls {
      facebookUrl
      isMainEventWall
    }
    isVerified
    seoMetadata {
      title
      description
    }
    alias {
      uri {
        url
      }
    }
    headerImageUrl
    imageUrl
    imageSmallUrl
    ticketShopUrl
    organizerShop {
      id
      organizerBranding {
        name
        image
      }
      hasDynamicProducts
    }
    location {
      id
      slug
      name
      background
      city {
        id
        slug
        name
      }
      country {
        name
      }
    }
    artists {
      id
      name
      slug
      avatar
      numberOfUpcomingEvents
    }
    types(first: 99) {
      edges {
        node {
          id
          slug
        }
      }
    }
    warning {
      title
      message
      url {
        text
        url
      }
    }
  }
`
